/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для страницы спецпредложений.
   */
  app.OffersListView = app.View.extend({
    el: '.offers-list',
    
    run: function () {
      var that = this;
      this.childViews.offerViews = [];
      this.inner = this.$('.category-promo-holder');
      _.each(this.inner, function (element) {
        that.childViews.offerViews.push(new app.OfferView({el: element}));
      });
    }
  });
})();

}.call(window));